const $ = jQuery.noConflict();
/* eslint-disable */
'use strict';

const MyAccount = {
	init: function() {
		if (!window.location.pathname.includes('/edit-address')) {
			return;
		}
		this.changeAddressHeaderNames()
		this.handleAddressDelete()
		this.makePrimaryAddressHandler()
		this.removeAdditionalAddressesHeader()
	},


	changeAddressHeaderNames: function() {
		$('.billing_address_book').children('header').children('h3').text('Billing Address');
		$('.shipping_address_book').children('header').children('h3').text('Shipping Address');
	},


	handleAddressDelete: function() {
		$('.js-remove-address').on('click', function(e) {
			MyAccount.sendRequest($(e.target).attr('id'), 'wc_address_book_delete', woo_address_book.delete_security);
		});
	},


	sendRequest: function(id, action, nonce) {
		$.ajax({
			url: window.fwsLocalized.ajaxUrl,
			type: 'POST',
			dataType: 'JSON',
			data: {
				action: action,
				name: id,
				nonce: nonce
			},
			complete: () => {
				window.location.reload()
			}
		});
	},


	makePrimaryAddressHandler: function() {
		$('.wc-address-book-make-primary').off('click');
		$('.wc-address-book-make-primary').on('click', function(e) {
			MyAccount.sendRequest($(e.target).attr('id'), 'wc_address_book_make_primary', woo_address_book.primary_security)
		});
	},


	removeAdditionalAddressesHeader: function() {
		// Using a timeout because the .add-addresses__holder element gets rendered a little late
		// therefore we can't check if the element exists or not on load
		setTimeout(() => {
			if ($('.add-addresses__holder').length === 0) {
				$('.woocommerce-Addresses--wrapper-additional-title').css('display', 'none')
			}
		}, 500)
	}
}

export default MyAccount;
